import { schema } from 'normalizr';

export const surveySchema: schema.Entity = new schema.Entity('surveys');

export const clusterSchema: schema.Entity = new schema.Entity('clusters', {
  surveys: [surveySchema]
});
